<template>
    <div>
        <el-form :inline="true" :model="queryParams" size="small" style="text-align: left; margin-top: 5px">
            <el-form-item label="学校选择">
                <el-select v-model="queryParams.schoolId" placeholder="请选择学校" :clearable="!schoolLocked" filterable :disabled="schoolLocked" @change="onSchoolChange">
                    <el-option
                            v-for="item in schoolList"
                            :key="item.schoolId"
                            :label="item.schoolName"
                            :value="item.schoolId">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>

        <el-tabs v-model="activeTab" @tab-click="onTabClick">
            <el-tab-pane label="商品" name="product">
                <el-form :inline="true" :model="queryParams" size="small">
                    <el-form-item label="名称">
                        <el-input v-model="queryParams.pointProduct" placeholder="商品名" clearable @keyup.enter.native="getProductList" />
                    </el-form-item>
                    <el-form-item label="类型">
                        <el-select v-model="queryParams.productType" placeholder="全部" clearable>
                            <el-option label="实物" value="goods" />
                            <el-option label="优惠券" value="coupon" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="queryParams.status" placeholder="全部" clearable>
                            <el-option label="下架" value="0" />
                            <el-option label="上架" value="1" />
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" :disabled="!queryParams.schoolId" @click="getProductList">查询</el-button>
                        <el-button icon="el-icon-refresh" size="mini" @click="resetProductQuery">重置</el-button>
                        <el-button type="primary" plain size="mini" :disabled="!queryParams.schoolId" @click="openProduct()">新增商品</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="productList" border style="width: 100%">
                    <el-table-column label="名称" prop="pointProduct" align="center" min-width="140" :show-overflow-tooltip="true" />
                    <el-table-column label="积分" prop="pointNum" align="center" width="90" />
                    <el-table-column label="类型" align="center" width="90">
                        <template slot-scope="scope">{{ scope.row.productType === 'coupon' ? '优惠券' : '实物' }}</template>
                    </el-table-column>
                    <el-table-column label="库存" align="center" width="90">
                        <template slot-scope="scope">
                            <span v-if="scope.row.stock == null">不限</span>
                            <span v-else>{{ scope.row.stock }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="每人限兑" align="center" width="90">
                        <template slot-scope="scope">{{ scope.row.perUserLimit > 0 ? scope.row.perUserLimit : '不限' }}</template>
                    </el-table-column>
                    <el-table-column label="状态" align="center" width="90">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status === '1'" size="small" type="success">上架</el-tag>
                            <el-tag v-else size="small" type="info">下架</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="220">
                        <template slot-scope="scope">
                            <el-button size="mini" type="text" @click="openProduct(scope.row)">编辑</el-button>
                            <el-button v-if="scope.row.status !== '1'" size="mini" type="text" @click="changeProductStatus(scope.row, '1')">上架</el-button>
                            <el-button v-else size="mini" type="text" @click="changeProductStatus(scope.row, '0')">下架</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        style="margin-top: 16px; text-align: right"
                        layout="total, prev, pager, next"
                        :current-page="queryParams.pageNum"
                        :page-size="queryParams.pageSize"
                        :total="productTotal"
                        @current-change="handleProductPage">
                </el-pagination>
            </el-tab-pane>

            <el-tab-pane label="兑换单" name="order">
                <el-form :inline="true" :model="orderQuery" size="small">
                    <el-form-item label="手机号">
                        <el-input v-model="orderQuery.userPhone" placeholder="手机号" clearable @keyup.enter.native="getOrderList" />
                    </el-form-item>
                    <el-form-item label="类型">
                        <el-select v-model="orderQuery.productType" placeholder="全部" clearable>
                            <el-option label="实物" value="goods" />
                            <el-option label="优惠券" value="coupon" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="orderQuery.status" placeholder="全部" clearable>
                            <el-option label="待发货" value="0" />
                            <el-option label="已发货" value="1" />
                            <el-option label="已完成" value="2" />
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" :disabled="!queryParams.schoolId" @click="getOrderList">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="orderList" border style="width: 100%">
                    <el-table-column label="商品" prop="pointProduct" align="center" min-width="140" :show-overflow-tooltip="true" />
                    <el-table-column label="类型" align="center" width="90">
                        <template slot-scope="scope">{{ scope.row.productType === 'coupon' ? '优惠券' : '实物' }}</template>
                    </el-table-column>
                    <el-table-column label="积分" prop="pointNum" align="center" width="80" />
                    <el-table-column label="用户/收件人" align="center" width="120" :show-overflow-tooltip="true">
                        <template slot-scope="scope">{{ scope.row.userName || '-' }}</template>
                    </el-table-column>
                    <el-table-column label="手机号" align="center" width="120">
                        <template slot-scope="scope">{{ scope.row.userPhone || '-' }}</template>
                    </el-table-column>
                    <el-table-column label="地址" align="center" min-width="160" :show-overflow-tooltip="true">
                        <template slot-scope="scope">{{ [scope.row.area, scope.row.detailedAddress].filter(Boolean).join(' ') || '-' }}</template>
                    </el-table-column>
                    <el-table-column label="状态" align="center" width="90">
                        <template slot-scope="scope">{{ orderStatusText(scope.row) }}</template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="160">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.productType !== 'coupon' && scope.row.status === '0'" size="mini" type="text" @click="changeOrderStatus(scope.row, '1')">发货</el-button>
                            <el-button v-if="scope.row.productType !== 'coupon' && scope.row.status === '1'" size="mini" type="text" @click="changeOrderStatus(scope.row, '2')">完成</el-button>
                            <span v-if="scope.row.productType === 'coupon'" style="color:#909399">只读</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        style="margin-top: 16px; text-align: right"
                        layout="total, prev, pager, next"
                        :current-page="orderQuery.pageNum"
                        :page-size="orderQuery.pageSize"
                        :total="orderTotal"
                        @current-change="handleOrderPage">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>

        <el-dialog :title="productTitle" :visible.sync="productOpen" width="560px" @close="resetProductForm">
            <el-form ref="productForm" :model="productForm" :rules="productRules" label-width="100px" size="small">
                <el-form-item label="学校" prop="schoolId">
                    <el-select v-model="productForm.schoolId" placeholder="请选择学校" :disabled="!!productForm.id || schoolLocked" filterable>
                        <el-option
                                v-for="item in schoolList"
                                :key="item.schoolId"
                                :label="item.schoolName"
                                :value="item.schoolId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="名称" prop="pointProduct">
                    <el-input v-model="productForm.pointProduct" maxlength="50" />
                </el-form-item>
                <el-form-item label="积分价" prop="pointNum">
                    <el-input-number v-model="productForm.pointNum" :min="1" :precision="0" />
                </el-form-item>
                <el-form-item label="类型" prop="productType">
                    <el-radio-group v-model="productForm.productType" :disabled="!!productForm.id">
                        <el-radio label="goods">实物</el-radio>
                        <el-radio label="coupon">优惠券</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="productForm.productType === 'coupon'" label="券模板" prop="couponId">
                    <el-select v-model="productForm.couponId" placeholder="本校已发布券" filterable>
                        <el-option
                                v-for="item in couponList"
                                :key="item.id"
                                :label="item.couponName + '（' + item.money + '元）'"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="库存">
                    <el-input-number v-model="productForm.stock" :min="-1" />
                    <div style="color:#909399;font-size:12px;">空或不填表示不限；-1 也会按不限保存</div>
                </el-form-item>
                <el-form-item label="每人限兑">
                    <el-input-number v-model="productForm.perUserLimit" :min="0" :precision="0" />
                    <div style="color:#909399;font-size:12px;">0 表示不限</div>
                </el-form-item>
                <el-form-item label="图片">
                    <el-input v-model="productForm.imgUrl" placeholder="请上传图片" readonly style="margin-bottom: 8px" />
                    <el-upload
                            class="avatar-uploader"
                            action="#"
                            :http-request="handleUpload"
                            :show-file-list="false"
                            :before-upload="beforeUpload"
                            accept="image/*">
                        <img v-if="productForm.imgUrl" :src="productForm.imgUrl" style="width: 120px; height: 80px; object-fit: cover;">
                        <i v-else class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="productOpen = false">取 消</el-button>
                <el-button type="primary" :loading="productSaving" @click="submitProduct">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { isSchoolScoped, getBoundSchoolId, lockSchoolOptions } from '@/utils/schoolScope'
export default {
    name: 'Exchange',
    computed: {
        schoolLocked() {
            return isSchoolScoped()
        }
    },
    data() {
        return {
            activeTab: 'product',
            schoolList: [],
            couponList: [],
            productList: [],
            productTotal: 0,
            orderList: [],
            orderTotal: 0,
            productOpen: false,
            productTitle: '新增商品',
            productSaving: false,
            queryParams: {
                schoolId: null,
                pointProduct: '',
                productType: '',
                status: '',
                pageNum: 1,
                pageSize: 10
            },
            orderQuery: {
                userPhone: '',
                productType: '',
                status: '',
                pageNum: 1,
                pageSize: 10
            },
            productForm: this.emptyProduct(),
            productRules: {
                schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }],
                pointProduct: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                pointNum: [{ required: true, message: '请输入积分价', trigger: 'blur' }],
                productType: [{ required: true, message: '请选择类型', trigger: 'change' }],
                couponId: [{
                    validator: (rule, value, callback) => {
                        if (this.productForm.productType === 'coupon' && (value === null || value === undefined || value === '')) {
                            callback(new Error('请选择券模板'))
                        } else {
                            callback()
                        }
                    },
                    trigger: 'change'
                }]
            }
        }
    },
    created() {
        this.getSchoolList()
    },
    methods: {
        emptyProduct() {
            return {
                id: null,
                schoolId: null,
                pointProduct: '',
                pointNum: 100,
                productType: 'goods',
                couponId: null,
                stock: undefined,
                perUserLimit: 0,
                imgUrl: '',
                status: '0'
            }
        },
        orderStatusText(row) {
            if (row.productType === 'coupon') {
                return '已完成'
            }
            if (row.status === '1') {
                return '已发货'
            }
            if (row.status === '2') {
                return '已完成'
            }
            return '待发货'
        },
        async getSchoolList() {
            const res = await this.$http.get('/school/AppGetCampusSchoolList')
            if (res.data.code === 200) {
                this.schoolList = lockSchoolOptions(res.data.data || [])
                if (isSchoolScoped() && getBoundSchoolId() != null) {
                    this.queryParams.schoolId = getBoundSchoolId()
                    this.onSchoolChange()
                }
            }
        },
        onSchoolChange() {
            this.queryParams.pageNum = 1
            this.orderQuery.pageNum = 1
            if (!this.queryParams.schoolId) {
                this.productList = []
                this.productTotal = 0
                this.orderList = []
                this.orderTotal = 0
                return
            }
            this.loadCoupons()
            if (this.activeTab === 'order') {
                this.getOrderList()
            } else {
                this.getProductList()
            }
        },
        onTabClick() {
            if (!this.queryParams.schoolId) {
                return
            }
            if (this.activeTab === 'order') {
                this.getOrderList()
            } else {
                this.getProductList()
            }
        },
        async loadCoupons() {
            const res = await this.$http.get('/coupon/getPublishedList', { params: { schoolId: this.queryParams.schoolId } })
            if (res.data.code === 200) {
                this.couponList = res.data.data || []
            }
        },
        async getProductList() {
            if (!this.queryParams.schoolId) {
                this.$message.warning('请选择学校')
                return
            }
            const res = await this.$http.get('/admin/pointProduct/list', { params: this.queryParams })
            if (res.data.code === 200) {
                const page = res.data.data || {}
                this.productList = page.children || []
                this.productTotal = page.total || 0
            } else {
                this.$message.error(res.data.msg || '查询失败')
            }
        },
        resetProductQuery() {
            this.queryParams.pointProduct = ''
            this.queryParams.productType = ''
            this.queryParams.status = ''
            this.queryParams.pageNum = 1
            if (!this.schoolLocked) {
                this.queryParams.schoolId = null
                this.productList = []
                this.productTotal = 0
                return
            }
            this.getProductList()
        },
        handleProductPage(page) {
            this.queryParams.pageNum = page
            this.getProductList()
        },
        async getOrderList() {
            if (!this.queryParams.schoolId) {
                this.$message.warning('请选择学校')
                return
            }
            const res = await this.$http.get('/admin/exchange/list', {
                params: {
                    schoolId: this.queryParams.schoolId,
                    userPhone: this.orderQuery.userPhone,
                    productType: this.orderQuery.productType,
                    status: this.orderQuery.status,
                    pageNum: this.orderQuery.pageNum,
                    pageSize: this.orderQuery.pageSize
                }
            })
            if (res.data.code === 200) {
                const page = res.data.data || {}
                this.orderList = page.children || []
                this.orderTotal = page.total || 0
            } else {
                this.$message.error(res.data.msg || '查询失败')
            }
        },
        handleOrderPage(page) {
            this.orderQuery.pageNum = page
            this.getOrderList()
        },
        openProduct(row) {
            if (row) {
                this.productTitle = '编辑商品'
                this.productForm = Object.assign(this.emptyProduct(), row)
                if (this.productForm.stock == null) {
                    this.productForm.stock = undefined
                }
            } else {
                this.productTitle = '新增商品'
                this.productForm = this.emptyProduct()
                this.productForm.schoolId = this.queryParams.schoolId
            }
            this.loadCoupons()
            this.productOpen = true
        },
        resetProductForm() {
            this.productForm = this.emptyProduct()
            if (this.$refs.productForm) {
                this.$refs.productForm.clearValidate()
            }
        },
        beforeUpload(file) {
            if (!file.type.startsWith('image/')) {
                this.$message.error('只能上传图片文件!')
                return false
            }
            if (file.size / 1024 / 1024 >= 2) {
                this.$message.error('图片大小不能超过 2MB!')
                return false
            }
            return true
        },
        async handleUpload(param) {
            const formData = new FormData()
            formData.append('file', param.file)
            const res = await this.$http.post('/upload', formData)
            if (res.data.code === 200) {
                this.productForm.imgUrl = res.data.data
                this.$message.success('上传成功')
            } else {
                this.$message.error(res.data.msg || '上传失败')
            }
        },
        submitProduct() {
            this.$refs.productForm.validate(async valid => {
                if (!valid) {
                    return
                }
                const payload = Object.assign({}, this.productForm)
                if (payload.stock === '' || payload.stock === undefined || payload.stock < 0) {
                    payload.stock = null
                }
                if (payload.productType !== 'coupon') {
                    payload.couponId = null
                }
                this.productSaving = true
                try {
                    const res = await this.$http.post('/admin/pointProduct/save', payload)
                    if (res.data.code === 200) {
                        this.$message.success('保存成功')
                        this.productOpen = false
                        this.getProductList()
                    } else {
                        this.$message.error(res.data.msg || '保存失败')
                    }
                } finally {
                    this.productSaving = false
                }
            })
        },
        async changeProductStatus(row, status) {
            const res = await this.$http.post('/admin/pointProduct/changeStatus', null, {
                params: { id: row.id, status }
            })
            if (res.data.code === 200) {
                this.$message.success('已更新')
                this.getProductList()
            } else {
                this.$message.error(res.data.msg || '更新失败')
            }
        },
        async changeOrderStatus(row, status) {
            const res = await this.$http.post('/admin/exchange/changeStatus', null, {
                params: { id: row.id, status }
            })
            if (res.data.code === 200) {
                this.$message.success('已更新')
                this.getOrderList()
            } else {
                this.$message.error(res.data.msg || '更新失败')
            }
        }
    }
}
</script>
